import classnames from 'classnames';
import StdListContext from 'contexts/StdListContext';
import React from 'react';

interface Props {
  children: React.ReactNode;
  selected: boolean;
  onClick: (evt: React.MouseEvent<HTMLElement>) => void | null;
  className?: string;
  style?: React.CSSProperties;
  noHover: boolean;
  id: string;
  rowHeight?: string;
}

class StdListRow extends React.Component<Props> {
  static defaultProps = {
    selected: false,
    onClick: null,
    className: '',
    style: {},
    noHover: false,
    rowHeight: '4rem',
  };

  render(): React.ReactNode {
    const {
      children,
      selected,
      onClick,
      id,
      className,
      style,
      noHover,
      rowHeight,
    } = this.props;

    return (
      <StdListContext.Consumer>
        {({ id: listId, gridTemplateColumns }): React.ReactNode => (
          <div
            id={id}
            className={classnames(
              `${listId}-row`,
              className,
              'bb-solid bb-width-2 bb-gray-3',
              {
                'std-list-row': !noHover,
                'std-list-row-no-hover': noHover,
                'bgd-white': !selected,
                selected,
                'cursor-pointer': onClick !== null,
              }
            )}
            style={{
              display: 'grid',
              gridTemplateColumns,
              gridTemplateRows: rowHeight,
              alignItems: 'center',
              ...style,
            }}
            onClick={onClick}
          >
            {children}
          </div>
        )}
      </StdListContext.Consumer>
    );
  }
}

export default StdListRow;
